import { render, staticRenderFns } from "./ReportData.vue?vue&type=template&id=f5f06a54&scoped=true&"
import script from "./ReportData.vue?vue&type=script&lang=js&"
export * from "./ReportData.vue?vue&type=script&lang=js&"
import style0 from "./ReportData.vue?vue&type=style&index=0&id=f5f06a54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f06a54",
  null
  
)

export default component.exports